"use client"

import gsap from "gsap"
import Lenis from "lenis"
import { useEffect, useRef } from "react"

export default function SmoothScroll() {
    const lenisRef = useRef<Lenis | null>(null)

    useEffect(() => {
        const lenis = new Lenis({
            duration: 0.7,
            orientation: "vertical",
            gestureOrientation: "vertical",
            smoothWheel: true,
        })
        lenisRef.current = lenis

        // Synchronize Lenis scroll with GSAP's ticker
        const update = (time: number) => {
            lenis.raf(time * 1000)
        }

        gsap.ticker.add(update)
        gsap.ticker.lagSmoothing(0)

        return () => {
            lenis.destroy()
            gsap.ticker.remove(update)
        }
    }, [])

    return null
}
